/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InsuranceCarrierDetailsIntegrationViewModel {
  /**
   * Insurance Carrier Id (not used for Add)
   */
  id?: string | null;
  /**
   * Dataset Id (not used for Add)
   */
  datasetId?: string | null;
  /**
   * Insurance Carrier code, max length 50
   */
  carrierCode?: string | null;
  /**
   * Insurance Carrier Name, max length 100
   */
  carrierName?: string | null;
  /**
   * Insurance Carrier Address Line 1, max length 100
   */
  address1?: string | null;
  /**
   * Insurance Carrier Address Line 2, max length 100
   */
  address2?: string | null;
  /**
   * Insurance Carrier City, max length 50
   */
  city?: string | null;
  /**
   * Insurance Carrier State Code, must be a valid US state code
   */
  stateCode?: string | null;
  /**
   * Insurance Carrier Zipcode, max length 20
   */
  zip?: string | null;
  /**
   * Insurance Carrier Phone Number, max length 20
   */
  phoneNumber?: string | null;
  /**
   * Option to hold insurance billing for this carrier
   */
  carrierHoldBilling?: string | null;
  /**
   * Option to require Referring Provider on all claims for this carrier
   */
  carrierReferringProviderRequired?: string | null;
  /**
   * Option to require Policy Number on all patient insurance records for this carrier
   */
  carrierPolicyNumberRequired?: string | null;
  /**
   * Option to require Group Number on all patient insurance records for this carrier
   */
  carrierGroupNumberRequired?: string | null;
  /**
   * Insurance Carrier type, must be a valid insurance carrier type
   */
  insuranceCarrierType?: string | null;
  /**
   * Type of claim to bill. Valid options are \'Electronic\', \'Paper\', and \'Institutional\'.
   */
  carrierClaimType?: string | null;
  /**
   * Phicure PayerId for electronic claims, max length 50
   */
  payerId?: string | null;
  /**
   * Procedure Insurance Code to use for this carrier. Valid values are 1, 2, 3, 4, or 5. Defaults to 1.
   */
  chargeInsuranceCode?: string | null;
  /**
   * Financial class code for insurance carrier, max length 4
   */
  financialClassCode?: string | null;
  /**
   * Financial class name for insurance carrier, max length 100
   */
  financialClassName?: string | null;
  /**
   * Default Financial Class Id for this carrier (not used for Add)
   */
  financialClassId?: string;
  /**
   * Payment Fee Schedule Name, max length 100
   */
  paymentFeeScheduleName?: string | null;
  /**
   * Payment Fee Schedule Id (not used for Add)
   */
  feeScheduleId?: string | null;
  /**
   * Procedure Fee Schedule Name, max length 100
   */
  procedureFeeScheduleName?: string | null;
  /**
   * Procedure Fee Schedule Id (not used for Add)
   */
  procedureFeeScheduleId?: string | null;
  /**
   * Option to Accept Assignment for this Carrier on Claims
   */
  carrierAcceptAssignment?: string | null;
  /**
   * Refund Address Name, max length 100
   */
  refundName?: string | null;
  /**
   * Refund Address Line1, max length 100
   */
  refundAddress1?: string | null;
  /**
   * Refund Address Line2, max length 100
   */
  refundAddress2?: string | null;
  /**
   * Refund Address City, max length 50
   */
  refundCity?: string | null;
  /**
   * Refund State Code,  must be a valid US state code
   */
  refundStateCode?: string | null;
  /**
   * Refund Zipcode, max length 20
   */
  refundZip?: string | null;
  /**
   * Option to send DOL Provider Id
   */
  useDeptOfLabor?: string | null;
  /**
   * Insurance Carrier email address, max length 100
   */
  email?: string | null;
  /**
   * Option to make carrier inactive
   */
  carrierInactive?: string | null;
  /**
   * Default Medicare Secondary Insurance Type, must be a valid insurance type code
   */
  defaultSecondaryInsuranceType?: string | null;
  /**
   * Default Insurance Type Id (not used for add)
   */
  defaultInsuranceTypeId?: string | null;
  /**
   * Option to exclude eligibility checks for this carrier
   */
  carrierExcludeEligibility?: string | null;
  /**
   * Option to require authorization for visits billed to carrier
   */
  carrierAuthRequired?: string | null;
}
